<template>
  <div
    class="TeamAssetItem position-relative rounded cursor-pointer"
  >
    <Card
      class="TeamAssetItem__card"
      :class="{ 'TeamAssetItem--selected': isSelected }"
      @click.prevent="select"
    >
      <TeamAssetItemCover
        class="TeamAssetItem__cover"
      />

      <CardContent class="tw:py-0 tw:px-2">
        <TeamAssetItemTitle
          class="TeamAssetItem__title"
        />
      </CardContent>
    </Card>

    <TeamAssetItemMenu />
  </div>
</template>

<script>
import { computed } from 'vue'
import {
  Card,
  CardContent,
} from '@/shadcn/components/ui/card'
import TeamAssetItemCover from './team-asset-item-cover.vue'
import TeamAssetItemMenu from './team-asset-item-menu.vue'
import TeamAssetItemTitle from './team-asset-item-title.vue'
import { useProvideTeamAssetItem } from './use-team-asset-item'
import { useTeamAssets } from './use-team-assets'

export default {
  name: 'TeamAssetItem',
  components: {
    TeamAssetItemCover,
    TeamAssetItemTitle,
    TeamAssetItemMenu,
    Card,
    CardContent,
  },
  props: {
    teamAsset: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const teamAsset = computed(() => props.teamAsset)

    useProvideTeamAssetItem(teamAsset)

    const { teamAssetSelected } = useTeamAssets()

    const isSelected = computed(() => props.teamAsset.hash_id === teamAssetSelected.value?.hash_id)

    const select = () => {
      if (isSelected.value) {
        teamAssetSelected.value = undefined
      }

      teamAssetSelected.value = props.teamAsset
    }

    return {
      isSelected,
      select,
    }
  },
}
</script>

<style lang="scss" scoped>
$height-image: 140px;
$height-title: 50px;

.TeamAssetItem {
  &:hover {
    outline: var(--primary) solid 2px;
  }

  &--selected {
    border-color: var(--primary);
  }

  &__card {
    height: $height-image + $height-title;
  }

  &__cover {
    height: $height-image;
  }

  &__title {
    height: $height-title;
  }
}
</style>
